import React from 'react';
import styled from 'styled-components';

// Container for the loading bar
const LoadingBarContainer = styled.div`
  width: 100%;
  height: 25px;
  background-color: ${({ theme }) => (theme === 'dark' ? '#2c3e50' : '#f4f7fb')};
  border-radius: 20px;
  margin-top: 20px;
  position: relative;
  overflow: hidden;
  box-shadow: ${({ theme }) => theme === 'dark' ? '0 6px 15px rgba(0, 0, 0, 0.2)' : '0 6px 20px rgba(0, 0, 0, 0.1)'};
  border: 1px solid ${({ theme }) => (theme === 'dark' ? '#34495e' : '#e0e4e7')};
`;

// Styled loading bar fill with gradient and smooth transition
const LoadingBar = styled.div.withConfig({
  shouldForwardProp: (prop) => prop !== 'progress', // Prevent the `progress` prop from being forwarded to the DOM
})`
  height: 100%;
  width: ${({ progress }) => progress}%;
  background: linear-gradient(90deg, rgba(52, 152, 219, 1), rgba(155, 89, 182, 1));
  box-shadow: ${({ theme }) => (theme === 'dark' ? '0 0 10px rgba(52, 152, 219, 0.7)' : '0 0 10px rgba(155, 89, 182, 0.3)')};
  border-radius: 20px;
  transition: width 0.4s ease-in-out;
`;


// Positioned text in the center with premium typography
const ProgressText = styled.div`
  position: absolute;
  top: 0;
  left: 50%;
  transform: translateX(-50%);
  color: ${({ theme }) => (theme === 'dark' ? '#fff' : '#2c3e50')};
  font-weight: 600;
  font-size: 14px;
  text-shadow: 0 2px 6px rgba(0, 0, 0, 0.1);  // Subtle text shadow
  z-index: 2;
`;

// Component for loading bar
const LoadingBarComponent = ({ progress, theme }) => {
  return (
    <LoadingBarContainer theme={theme}>
      <LoadingBar progress={progress} theme={theme} />
      <ProgressText theme={theme}>{progress}%</ProgressText>
    </LoadingBarContainer>
  );
};

export default LoadingBarComponent;
